import { render, staticRenderFns } from "./TheNavBarDesktopItem.vue?vue&type=template&id=14056130&scoped=true&"
import script from "./TheNavBarDesktopItem.vue?vue&type=script&lang=js&"
export * from "./TheNavBarDesktopItem.vue?vue&type=script&lang=js&"
import style0 from "./TheNavBarDesktopItem.vue?vue&type=style&index=0&id=14056130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14056130",
  null
  
)

export default component.exports